module.exports = __webpack_public_path__ + "static/media/appStore.44b9d037.png";